import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'MG',
    quote: 'Estaba aterrada con mi primer embarazo y este ebook me hizo sentir acompañada de verdad. Lo leía y sentía calma.',
    author: 'Martina G.',
    location: 'Córdoba',
    color: 'bg-peach-bg text-peach-dark'
  }, {
    initials: 'LP',
    quote: 'Internet me generaba más ansiedad que tranquilidad. Acá encontré explicaciones simples y reales.',
    author: 'Lucía P.',
    location: 'Rosario',
    color: 'bg-sage-light text-sage'
  }, {
    initials: 'RM',
    quote: 'El bonus de primeros auxilios me dio muchísima seguridad. Ahora siento que sé cómo reaccionar mejor.',
    author: 'Romina M.',
    location: 'Buenos Aires',
    color: 'bg-peach-bg text-peach-dark'
  }];
  return <section className="py-20 md:py-28 bg-cream" data-id="element-302">
      <div className="max-w-6xl mx-auto px-6" data-id="element-303">
        <div className="text-center mb-16" data-id="element-304">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-305">
            ❤️ LO QUE DICEN LAS MAMÁS
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-306">
            Más de 2.000 mamás ya viven
            <br data-id="element-307" />
            su maternidad con más calma
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-308">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm border border-peach-light/50 relative" data-id="element-309">
              <div className="absolute -top-6 left-8" data-id="element-310">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-serif font-bold text-lg ${t.color}`} data-id="element-311">
                  {t.initials}
                </div>
              </div>
              <div className="flex text-yellow-500 mb-4 mt-2" data-id="element-312">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-313" />)}
              </div>
              <p className="text-text-dark italic mb-6 leading-relaxed" data-id="element-314">
                "{t.quote}"
              </p>
              <div className="flex flex-col" data-id="element-315">
                <span className="font-medium text-text-dark" data-id="element-316">{t.author}</span>
                <span className="text-sm text-text-muted" data-id="element-317">— {t.location}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}